import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  getExecutiveClientCandidateOptions,
  getExecutiveClientPersonDetailOptions,
} from 'client/@tanstack/react-query.gen';

const executiveUserPeopleDetailSearchSchema = z.object({
  dialog: z.string().optional().catch(undefined),
  object_type: z.enum(['candidate', 'person']).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/users/$userId/people/$candidateId',
)({
  validateSearch: executiveUserPeopleDetailSearchSchema,
  beforeLoad: async ({ context, params, search }) => {
    const { queryClient } = context;
    if (search.object_type === 'candidate') {
      await queryClient.ensureQueryData(
        getExecutiveClientCandidateOptions({
          path: {
            candidate_uuid: params.candidateId,
            person_uuid: params.userId,
          },
        }),
      );
      return;
    }
    if (search.object_type === 'person') {
      await queryClient.ensureQueryData(
        getExecutiveClientPersonDetailOptions({
          path: {
            contact_person_uuid: params.candidateId,
            person_uuid: params.userId,
          },
        }),
      );
    }
  },
});
